import type { BaseIntegrationStatus } from '../api/integrationsApi';
import type { IntegrationStatus } from '../components/IntegrationCard';

/** An integration's status as the card shows it. */
export function mapStatus(data: BaseIntegrationStatus | undefined): IntegrationStatus {
  if (!data) return 'DISCONNECTED';
  if (data.connected && data.status === 'connected') return 'CONNECTED';
  if (data.status === 'expired') return 'EXPIRED';
  if (data.status === 'error') return 'ERROR';
  return 'DISCONNECTED';
}

/** The card's detail lines: the integration's own, then when it last synced. Nothing while disconnected. */
export function buildMetadata<T extends BaseIntegrationStatus>(
  data: T | undefined,
  extras: (data: T) => { label: string; value: string }[],
): { label: string; value: string }[] {
  if (!data || !data.connected || data.status !== 'connected') return [];
  const items = extras(data);
  if (data.lastSyncAt) {
    items.push({ label: 'Last synced', value: new Date(data.lastSyncAt).toLocaleString() });
  }
  return items;
}
